import styled from 'styled-components';
import media from "styled-query"

export const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  z-index: 99999;
  background: transparent;
  position: absolute;
  width: 100%;

  ${media.lessThan("1023px")`
    height: 124px;
  `}

  /* background: #0000ff4a; */
`;

export const Container = styled.div`
  width: 1120px;
  display: flex;
  justify-content: space-between;
  margin: 0;
  
  ${media.lessThan("1120px")`
    margin: 24px;
  `}
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;

  ul {
    display: flex;
    flex-direction: row;
    position: relative;
    width: unset;
    margin: unset;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;

    li {
      height: 100%;
      border-radius: unset;
      background: unset;
      list-style: none;
      margin-left: 20px;
      color: var(--white);
      transition: color 0.5s;
      
      &:not(.spotlight):hover {
        color: var(--secondary);
        transition: color 0.5s;
      }
    }
    
    .spotlight {
      background: var(--primary);
      height: 30px;
      border-radius: 7px;
      align-items: center;
      display: flex;
      color: var(--white);
      font-weight: bold;
      width: 150px;
      height: 40px;

      &:hover {
        transition: all 0.5s;
        background: var(--secondary);
        cursor: pointer;
      }
    }

    a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

  ${media.lessThan("1023px")`
    display: none;
  `}
`;

export const DivNavMobile = styled.div`
  display: none;
  align-items: center;

  ${media.lessThan("1023px")`
    display: flex;
  `}
`;

export const BtnMobile = styled.div`
  //
  /* background: #ff000059; */
  display: ${({ isOpen }) => isOpen ? 'flex' : 'none' };
`;

export const NavMobile = styled(Nav)`
  /* display: ${({ isOpen }) => isOpen ? 'flex' : 'none' }; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: var(--black);
  z-index: 9999;
  position: fixed;
  width: 80vw;
  height: 100vh;
  top: 0;
  left: 0;
  transition: transform 1000ms;
  transform: translateX(150%);
  transform: ${({ isOpen }) => isOpen ? 'translateX(0)' : 'translateX(150%)' };
  padding: 30px;

  ul {
    flex-direction: column;
    font-size: 1.5rem;
    margin-top: 30px;

    li {
      margin: 1rem 0;
    }
    
    .spotlight {
      background: var(--primary);
      width: 200px;
      padding: 30px;
    }
  }

`;

export const Background = styled.div`
  /* display: ${({ isOpen }) => isOpen ? 'flex' : 'none' }; */
  display: flex;
  background: var(--black);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  opacity: 0.85;
  justify-content: flex-end;
  transition: transform 1000ms;
  transform: translateX(150%);
  transform: ${({ isOpen }) => isOpen ? 'translateX(0)' : 'translateX(150%)' };
`;

export const BackgroundClose = styled.div`
  background: var(--black);
  width: calc(20vw);
  height: 100vh;
  justify-content: center;
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
`;

export const BtnMobileClose = styled.div`
  background: var(--background);
  border: 1px solid #29292e78;
  width: 200px;
  padding: 30px;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: #29292e78;
  font-weight: bold;
  font-size: 2rem;
  width: 200px;
`;